import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from '@rocketlane/rocket-router';
import { NitroBrewRemote } from 'components/pages/nitro-brew-remote';
import { useAccountDataQuery } from 'queries/account';
import { ROUTE_PATHS } from '../routes-paths';
import { SecureRoute } from '../route-with-permission-check';
const AutopilotAgentRoute = ({ children })=>{
    var _data_accountMeta_features, _data_accountMeta;
    const { data, isLoading } = useAccountDataQuery();
    if (isLoading) {
        return null;
    }
    if (!(data === null || data === void 0 ? void 0 : (_data_accountMeta = data.accountMeta) === null || _data_accountMeta === void 0 ? void 0 : (_data_accountMeta_features = _data_accountMeta.features) === null || _data_accountMeta_features === void 0 ? void 0 : _data_accountMeta_features.autopilotAgent)) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: ROUTE_PATHS.ROOT,
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export const nitroBrewRoutes = [
    {
        path: ROUTE_PATHS.NITRO_BREW,
        children: [
            {
                index: true,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(AutopilotAgentRoute, {
                        children: /*#__PURE__*/ _jsx(NitroBrewRemote, {})
                    })
                })
            },
            {
                path: ROUTE_PATHS.MATCH_ALL,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(AutopilotAgentRoute, {
                        children: /*#__PURE__*/ _jsx(NitroBrewRemote, {})
                    })
                })
            }
        ]
    }
];
